export const getSidemenuSettings = () => ({
	accordionMode: true,
	showSelectedOption: true,
	selectedOptionClass: 'my-selected-option',
	subOptionIndentation: {
		md: '56px',
		ios: '64px',
		wp: '56px',
	},
	subOptionIndentationLevel3: {
		md: '66px',
		ios: '74px',
		wp: '66px',
	},
	arrowIcon: 'chevron-forward-outline',
	expandIcon: 'add-outline',
	indentSubOptionsWithoutIcons: true,
	itemHeight: {
		ios: 40,
		md: 40,
		wp: 40,
	},
});
